import { Controller } from "@hotwired/stimulus"
import debounced from 'debounced'

export default class extends Controller {
  static targets = [
    'clearBtn',
    'hiddenField',
    'input',
    'results'
  ]

  connect() {
    if (this.hiddenFieldTarget.value.length > 1) {
      this.setInputs(this.hiddenFieldTarget.value)
      this.clearBtnTarget.classList.remove('hidden')
    }

    debounced.initialize(['input'], { wait: 300 })
    window.addEventListener('click', (e) => {
      if (this.resultsTarget.contains(e.target)) { return }
      
      this.resultsTarget.classList.remove('open')
    })
  }

  async search() {
    const url = 'https://places.googleapis.com/v1/places:autocomplete'
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': 'AIzaSyDVlMsLVG5FZ3yGehZgQM4nyAEUXeG4B04'
      },
      body: JSON.stringify({
        input: this.inputTarget.value,
        includedPrimaryTypes: ['country', 'administrative_area_level_1', 'locality']
      })
    })
    let results = await response.json()

    if (response.status == 200) {
      this.resultsTarget.innerHTML = null
      this.resultsTarget.classList.add('open')

      if (results.hasOwnProperty('suggestions')) {
        results.suggestions.forEach(obj => {
          console.log(obj)
          this.resultsTarget.insertAdjacentHTML('beforeend', `<div class="result line-clamp-1 whitespace-nowrap overflow-ellipsis" data-action="click->places-autocomplete#select">${obj?.placePrediction?.text?.text}</div>`)
        })
      } else {
        this.resultsTarget.innerHTML = `<div class="p-2">No results found</div>`
      }
    }
  }

  select(e) {
    this.setInputs(e.target.innerText)
  }

  setInputs(text) {
    this.inputTarget.value = text
    this.inputTarget.setAttribute('disabled', 'disabled')
    this.hiddenFieldTarget.value = text
    this.resultsTarget.classList.remove('open')
    this.clearBtnTarget.classList.remove('hidden')
  }

  clear() {
    this.inputTarget.value = ''
    this.inputTarget.removeAttribute('disabled')
    this.hiddenFieldTarget.value = ''
    this.clearBtnTarget.classList.add('hidden')
  }
}
